import * as Styled from "./style";
import { useRouter } from "next/router";

type PackageImageProps = {
  packageImageUrl: string;
  borderTopRadius?: number;
  borderBottomRadius?: number;
};

/** アスペクト比が「9:16」のサンプルパッケージ画像を表示するために使用するコンポーネント */
export const SamplePackageImage = ({ packageImageUrl, borderTopRadius, borderBottomRadius }: PackageImageProps) => {
  const { pathname } = useRouter();
  // HACK: DivタグをImageタグに変更したい。webpを渡すためにもLazyImageに変更したい
  return (
    <Styled.DivBackgroundImage
      role="img"
      aria-label="サンプルパッケージ画像"
      packageImageUrl={packageImageUrl}
      borderTopRadius={borderTopRadius}
      borderBottomRadius={borderBottomRadius}
      isVodDetail={pathname.includes("/vod/detail")}
    />
  );
};
